import React from 'react';
import { Breadcrumb } from 'antd';
import { StyledWebhooksContainer } from '../styled';
import WebhooksList from './WebhooksList';
import WebhooksHeader from '../WebhooksHeader';
import useFetchWebhooksList from '../hooks/useWebhooksList';

const Webhooks = () => {
    const { data, error, isLoading }: any = useFetchWebhooksList({
        context: 'app'
    });

    if (isLoading) {
        return <p>Loading...</p>;
    }

    if (error) {
        return <p>Error: {error.message}</p>;
    }

    return (
        <StyledWebhooksContainer>
            <Breadcrumb>
                <Breadcrumb.Item>Webhooks</Breadcrumb.Item>
            </Breadcrumb>
            <WebhooksHeader webhookList={data} />
            <WebhooksList webhookList={data} />
        </StyledWebhooksContainer>
    );
}

export default Webhooks;